
import { Link } from "react-router-dom";
import { Navigation } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";
import { useAuth } from "@/contexts/AuthContext";
import { MobileMenu } from "./navigation/MobileMenu";
import { UserMenu } from "./navigation/UserMenu";
import { NavigationMenuItems } from "./navigation/NavigationMenuItems";

const NavigationBar = () => {
  const { session } = useAuth();
  const isMobile = useIsMobile();

  return (
    <div className="w-full bg-primary text-white py-4">
      <div className="container mx-auto flex items-center justify-between px-4">
        <Link to="/" className="flex items-center gap-2">
          <img 
            src="/lovable-uploads/White logo - no background.svg" 
            alt="On The Town NYC" 
            className="h-10 w-auto transition-transform duration-200 hover:scale-105"
          />
        </Link>
        
        <div className="flex items-center gap-4">
          {isMobile ? (
            <>
              {session && <UserMenu />}
              <MobileMenu />
            </>
          ) : (
            <>
              <NavigationMenu>
                <NavigationMenuList>
                  <NavigationMenuItem>
                    <NavigationMenuTrigger className="text-white bg-transparent hover:bg-primary-foreground/10">
                      Explore
                    </NavigationMenuTrigger>
                    <NavigationMenuContent>
                      <NavigationMenuItems />
                    </NavigationMenuContent>
                  </NavigationMenuItem>
                </NavigationMenuList>
              </NavigationMenu>
              <UserMenu />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default NavigationBar;
